import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
    
    const currentYear = new Date().getFullYear();
    return (
        <div style={{ justifyContent: 'flex-end' }}>
            <div className='footer py-4 d-flex flex-lg-column footerstyle' id='kt_footer' >
                <div className=' container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between'>
                    <div className='text-dark order-2 order-md-1'>
                        <span className='text-muted fw-semibold me-1'>
                            {currentYear}©  <Link to="/" className='text-gray-800 text-hover-primary' style={{ textDecoration: 'none' }}> HeyVisuals</Link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
